import { Alert, IconButton, styled } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useQueryErrorResetBoundary } from "react-query";
import { Navigate } from "react-router-dom";
import { deserializeErrors } from "utils/ErrorUtils";

interface Props extends FallbackProps {}

export function AlertErrorBoundary(props: Props) {
  const { resetErrorBoundary, error } = props;
  const { t } = useTranslation();
  const { reset } = useQueryErrorResetBoundary();
  function resetError() {
    resetErrorBoundary();
    reset();
  }

  const errors = deserializeErrors(error);

  const doesStudyAreaExist = errors
    .map((e) => e.message)
    .includes("study_area_not_found");

  if (!doesStudyAreaExist) {
    return <Navigate to="/" />;
  }
  return (
    <>
      {doesStudyAreaExist && (
        <StyledAlert
          severity="error"
          action={
            <IconButton color="inherit" size="small" onClick={resetError}>
              <Refresh />
            </IconButton>
          }
        >
          {errors.map((error, index) => (
            <div key={index}>{t(error.message)}</div>
          ))}
        </StyledAlert>
      )}
    </>
  );
}

const StyledAlert = styled(Alert)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 2%;
  height: fit-content;
`;
